// extracted by mini-css-extract-plugin
export default {"root":"fJSc1e6heTMW94zEAcj3"};